import axios from "./http-incep";
import unincepaxios from "./http-unintercept";
import axiosforfile from "./http-incep-file";
import axiosforPDF from "./http-incep-pdf";
import axiosforExcel from "./http-incep-excel";
import axiosForReportAI from './report-ai-http-interceptor';
import axiosForBRSRXbrl from './brsr-xbrl-http-interceptor';
import axiosForPostExcel from "./http-incep-postExcel";
import axiosForReportingService from './reporting-http-interceptor';
import axiosForReportingServicePDF from './reporting-http-incep-pdf';
import axiosForScoket from './socket-http-interceptor';
import axiosForTranslation from './translate-http-interceptor';

export default class HttpUtil {
  static post(url, params = {}) {
    return axios.post(url, params, {});
  }
  static put(url, params = {}) {
    return axios.put(url, params, {});
  }
  static get(url, params = {}) {
    return axios.get(url, params);
  }
  static delete(url, params = {}) {
    return axios.delete(url, params);
  }
  static patch(url, params = {}) {
    return axios.patch(url, params);
  }

  //For APIs without Authorization header
  static uniterceptedPost(url, params = {}) {
    return unincepaxios.post(url, params, {});
  }
  static uniterceptedGet(url, params = {}) {
    return unincepaxios.get(url, params);
  }
  //For APIs without Authorization header end

  static getFileData(url, params = {}) {
    return axiosforfile.get(url, params);
  }

  static getPDFData(url, params = {}) {
    return axiosforPDF.get(url, params);
  }

  static getExcelData(url, params = {}) {
    return axiosforExcel.get(url, params);
  }

  static postForReportAI(url, params = {}) {
    return axiosForReportAI.post(url, params, {});
  }

  static postForBRSRXbrl(url, params = {}) {
    return axiosForBRSRXbrl.post(url, params, {});
  }

  static getFromReportAI(url, params = {}) {
    return axiosForReportAI.get(url, params);
  }

  static putForReportAI(url, params = {}) {
    return axiosForReportAI.put(url, params, {});
  }
  static deleteForReportAI(url, params = {}) {
    return axiosForReportAI.delete(url, params, {});
  }

  static postExcelData(url, params = {}) {
    return axiosForPostExcel.post(url, params);
  }

  static postForReportingService(url, params = {}) {
    return axiosForReportingService.post(url, params, {});
  }

  static getFromReportingService(url, params = {}) {
    return axiosForReportingService.get(url, params);
  }

  static putForReportingService(url, params = {}) {
    return axiosForReportingService.put(url, params, {});
  }

  static patchForReportingService(url, params = {}) {
    return axiosForReportingService.patch(url, params, {});
  }

  static deleteForReportingService(url, params = {}) {
    return axiosForReportingService.delete(url, params, {});
  }

  static getReportingPDFData(url, params = {}) {
    return axiosForReportingServicePDF.get(url, params);
  }

  static postForSocket(url, params = {}) {
    return axiosForScoket.post(url, params, {});
  }

  static postForTranslation(url, params = {}) {
    return axiosForTranslation.post(url, params, {});
  }
}
